export default __webpack_public_path__ + "static/media/pieChart.9b37df55.png";